"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
class ARootView extends React.Component {
    constructor() {
        super(...arguments);
        this.mainContentId = 'mainContent';
    }
}
exports.ARootView = ARootView;
